import { render, staticRenderFns } from "./PortEditContactDetails.vue?vue&type=template&id=079a47da&scoped=true"
import script from "./PortEditContactDetails.vue?vue&type=script&lang=js"
export * from "./PortEditContactDetails.vue?vue&type=script&lang=js"
import style0 from "./PortEditContactDetails.vue?vue&type=style&index=0&id=079a47da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a47da",
  null
  
)

export default component.exports